// Casca de modal no padrão Aeros Dark (cabeçalho 20/24/16 com título 16/700
// + subtítulo 12 + fechar, corpo com gap, rodapé com Cancelar / ação em
// gradiente). Usa os estilos compartilhados de styles/aerosModalStyles.js —
// os modais do Flowbuilder trocam DialogTitle/DialogActions por isto.
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import useAerosModalStyles from "../../styles/aerosModalStyles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  paper: ({ width }) => ({
    width,
    maxWidth: "calc(100vw - 32px)",
    maxHeight: "calc(var(--vh-full) - 48px)",
    margin: 16,
  }),
  bodyFlush: { padding: 0, gap: 0 },
  headerRight: { marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 },
}));

const AerosDialog = ({
  open,
  onClose,
  title,
  subtitle,
  width = 560,
  headerIcon, // bloco à ESQUERDA do título (avatar/ícone do mockup)
  headerRight, // conteúdo extra à direita do título (toggle "Ativa", etc.)
  footerLeft, // conteúdo à esquerda no rodapé ("4 itens · ≈ 6 s")
  footer, // substitui o rodapé padrão
  onSubmit,
  submitLabel,
  submitIcon,
  submitDisabled = false,
  cancelLabel,
  loading = false,
  flushBody = false, // corpo sem padding (layouts em grid próprios)
  children,
  ...dialogProps
}) => {
  const m = useAerosModalStyles();
  const classes = useStyles({ width });
  return (
    <Dialog
      open={!!open}
      onClose={loading ? undefined : onClose}
      maxWidth={false}
      classes={{ paper: classes.paper }}
      scroll="paper"
      {...dialogProps}
    >
      <div className={m.form}>
        <div className={m.header}>
          {headerIcon}
          <div style={{ minWidth: 0 }}>
            <div className={m.title}>{title}</div>
            {subtitle && <div className={m.subtitle}>{subtitle}</div>}
          </div>
          {headerRight && <div className={classes.headerRight}>{headerRight}</div>}
          <IconButton
            className={m.closeButton}
            style={headerRight ? { marginLeft: 14 } : undefined}
            onClick={onClose}
            aria-label={i18n.t("aeros.header.close")}
            disabled={loading}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className={`${m.body} ${flushBody ? classes.bodyFlush : ""}`}>{children}</div>
        {footer !== undefined ? (
          footer
        ) : (
          <div className={m.footer}>
            {footerLeft}
            <div className={m.footerActions}>
              <Button className={m.cancelButton} onClick={onClose} disabled={loading}>
                {cancelLabel || i18n.t("aeros.flow.cancel")}
              </Button>
              {onSubmit && (
                <Button
                  variant="contained"
                  color="primary"
                  className={m.submitButton}
                  onClick={onSubmit}
                  disabled={submitDisabled || loading}
                  endIcon={submitIcon}
                >
                  {submitLabel || i18n.t("aeros.flow.save")}
                  {loading && <CircularProgress size={24} className={m.buttonProgress} />}
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AerosDialog;
